import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Link,
  Route,
  Redirect
} from 'react-router-dom'
import logo from './logo.svg';
import './App.css';
import './components/AppNav/AppNav'
import AppNav from './components/AppNav/AppNav';
import AppNavTabs from './components/AppNavTabs/AppNavTabs';
import AppDrawer from './components/AppDrawer/AppDrawer';
import { auth } from './firebase'
import Login from './components/Login/Login'

function PrivateRoute({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => authed === true
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/', state: { from: props.location } }} />}
    />
  )
}

function PublicRoute({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => authed === false
        ? <Component {...props} />
        : <Redirect to='/dashboard' />}
    />
  )
}

const Home = () => (
  <div>
    <h2>Home</h2>
  </div>
)

const About = () => (
  <div>
    <h2>About</h2>
  </div>
)

const Topic = ({ match }) => (
  <div>
    <h3>{match.params.topicId}</h3>
  </div>
)

// const Topics = ({ match }) => (
//   <div>
//     <h2>Topics</h2>
//     <ul>
//       <li>
//         <Link to={`${match.url}/rendering`}>
//           Rendering with React
//         </Link>
//       </li>
//       <li>
//         <Link to={`${match.url}/components`}>
//           Components
//         </Link>
//       </li>
//       <li>
//         <Link to={`${match.url}/props-v-state`}>
//           Props v. State
//         </Link>
//       </li>
//     </ul>

//     <Route path={`${match.path}/:topicId`} component={Topic} />
//     <Route exact path={match.path} render={() => (
//       <h3>Please select a topic.</h3>
//     )} />
//   </div>
// )
class Topics extends Component {

  render() {
    let { match } = this.props;
    return (
      <div>
        <h2>Topics</h2>
        <ul>
          <li>
            <Link to={`${match.url}/rendering`}>
              Rendering with React
        </Link>
          </li>
          <li>
            <Link to={`${match.url}/components`}>
              Components
        </Link>
          </li>
          <li>
            <Link to={`${match.url}/props-v-state`}>
              Props v. State
        </Link>
          </li>
        </ul>

        <Route path={`${match.path}/:topicId`} component={Topic} />
        <Route exact path={match.path} render={() => (
          <h3>Please select a topic.</h3>
        )} />
      </div>
    );
  }
}

class App extends Component {
  state = {
    authed: false,
    loading: true
  }
  
  componentDidMount() {
    this.removeListener = auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          authed: true,
          loading: false,
        })
      } else {
        this.setState({
          authed: false,
          loading: false
        })
      }
    })
  }

  componentWillUnmount () {
    this.removeListener()
  }

  render() {

    return this.state.loading === true ? <h1>Loading</h1> : (
      <div className="App">
        {/* <AppNav/> */}
        <Router>
          <div>
            <PrivateRoute authed={this.state.authed} path="/dashboard" component={AppDrawer} />
            <PublicRoute exact authed={this.state.authed} path="/" component={Login} />
            
            {/* <AppDrawer authed={this.state.authed} /> */}
          </div>
        </Router>
        {/* {this.state.authed ? <p>auth</p> : <p>no auth</p>} */}
        {/* <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to React</h1>
        </header>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>
        <Router>
          <div>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/topics">Topics</Link></li>
            </ul>

            <hr />

            <Route exact path="/" component={Home} />
            <Route path="/about" component={About} />
            <Route path="/topics" component={Topics} />
          </div>
        </Router> */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx